module.exports = __webpack_public_path__ + "static/media/ethan-allen_2x.c0ebb211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/ethan-allen_2x.jpg
// module id = 824
// module chunks = 27